const tableConfigurations = {
    articles: {
        requiredFields: ['date', 'name', 'title', 'summary', 'content', 'status'],
        fieldLabels: {
            date: '日期',
            name: '姓名',
            title: '標題',
            summary: '摘要',
            content: '內容',
            picture1: '圖片1',
            picture2: '圖片2',
            url: '網址',
            status: '狀態',
        },
        fieldTypes: {
            date: 'date',
            name: 'text',
            title: 'text',
            summary: 'text',
            content: 'wysiwyg',
            picture1: 'text',
            picture2: 'text',
            url: 'text',
            status: 'radio',
        },
    },
    testimonies: {
        requiredFields: ['date', 'name', 'title', 'summary', 'content', 'status'],
        fieldLabels: {
            date: '日期',
            name: '姓名',
            title: '標題',
            summary: '縮文',
            content: '內容',
            status: '狀態',
        },
        fieldTypes: {
            date: 'date',
            name: 'text',
            title: 'text',
            summary: 'text',
            content: 'wysiwyg',
            status: 'radio',
        },
    },
    sermons: {
        requiredFields: ['date', 'speaker', 'title', 'bible', 'content', 'status'],
        fieldLabels: {
            date: '日期',
            speaker: '講員',
            translator: '翻譯員',
            title: '標題',
            bible: '經文',
            content: '內容',
            file_id: '檔案ID',
            m3u: 'M3U網址',
            mp3: 'MP3網址',
            comment1: '附註1',
            comment2: '附註2',
            image1: '圖片1',
            image2: '圖片2',
            status: '狀態',
        },
        fieldTypes: {
            date: 'date',
            speaker: 'text',
            translator: 'text',
            title: 'text',
            bible: 'text',
            content: 'wysiwyg',
            file_id: 'text',
            m3u: 'text',
            mp3: 'text',
            comment1: 'text',
            comment2: 'text',
            image1: 'text',
            image2: 'text',
            status: 'radio',
        },
    },
    news: {
        requiredFields: ['date', 'title', 'content', 'status'],
        fieldLabels: {
            date: '日期',
            title: '標題',
            summary: '縮文',
            content: '內容',
            url: '網址',
            picture1: '圖片1',
            picture2: '圖片2',
            remark: '附註',
            status: '狀態',
        },
        fieldTypes: {
            date: 'date',
            title: 'text',
            summary: 'text',
            content: 'wysiwyg',
            url: 'text',
            picture1: 'text',
            picture2: 'text',
            remark: 'text',
            status: 'radio',
        },
    },
    redirects: {
        requiredFields: ['title', 'redirect_url', 'url_shortcut', 'status'],
        fieldLabels: {
            title: '主題',
            redirect_url: '導向網址',
            url_shortcut: '短網址',
            remark: '附註',
            status: '狀態',
        },
        fieldTypes: {
            title: 'text',
            redirect_url: 'text',
            url_shortcut: 'text',
            remark: 'text',
            status: 'radio',
        },
    },
    pastor_messages: {
        requiredFields: ['date', 'name', 'title', 'content', 'status'],
        fieldLabels: {
            date: '日期',
            name: '姓名',
            title: '標題',
            content: '內容',
            remark: '附註',
            status: '狀態',
        },
        fieldTypes: {
            date: 'date',
            name: 'text',
            title: 'text',
            content: 'wysiwyg',
            remark: 'text',
            status: 'radio',
        },
    },
    page_content_2: {
        requiredFields: ['date', 'title', 'content', 'category', 'status'],
        fieldLabels: {
            date: '日期',
            title: '主題',
            content: '內容',
            category: '類別',
            picture1: '圖片1',
            picture2: '圖片2',
            url: '網址',
            status: '狀態',
        },
        fieldTypes: {
            date: 'date',
            title: 'text',
            content: 'wysiwyg',
            category: 'dropdown',
            picture1: 'text',
            picture2: 'text',
            url: 'text',
            status: 'radio',
        },
    },
    fellowship_schedules: {
        requiredFields: ['datetime', 'event', 'venue', 'status'],
        fieldLabels: {
            datetime: '日期時間',
            event: '團契名稱',
            orders: '順序',
            venue: '地點',
            remark: '附註',
            status: '狀態',
        },
        fieldTypes: {
            datetime: 'text',
            event: 'text',
            orders: 'text',
            venue: 'text',
            remark: 'text',
            status: 'radio',
        },
    },
    devotion_sharings: {
        requiredFields: ['date', 'name', 'title', 'bible', 'content', 'status'],
        fieldLabels: {
            date: '日期',
            name: '姓名',
            title: '標題',
            bible: '經文',
            content: '內容',
            remark: '附註',
            status: '狀態',
        },
        fieldTypes: {
            date: 'date',
            name: 'text',
            title: 'text',
            bible: 'text',
            content: 'wysiwyg',
            remark: 'text',
            status: 'radio',
        },
    },
    bible_study_materials: {
        requiredFields: ['date', 'name', 'title', 'bible', 'content', 'target', 'status'],
        fieldLabels: {
            date: '日期',
            name: '姓名',
            title: '標題',
            bible: '經文',
            content: '內容',
            remark: '附註',
            target: '用戶對象 (1=管理員；2=組長；3=對外開放)',
            status: '狀態',
        },
        fieldTypes: {
            date: 'date',
            name: 'text',
            title: 'text',
            bible: 'text',
            content: 'wysiwyg',
            remark: 'text',
            target: 'dropdown',
            status: 'radio',
        },
    },
};

module.exports = tableConfigurations;